import type { TypeCollection } from './Graph';

export class NotEqualPrototypesError extends Error {
  public constructor(expectedProto: TypeCollection, providedProto: TypeCollection) {
    super(
      'Not equal prototypes.' +
        '\n  Expected: [' +
        expectedProto.map((x) => x.name).join(',') +
        ']\n  Provided: [' +
        providedProto.map((x) => x.name).join(',') +
        ']'
    );
    Object.setPrototypeOf(this, NotEqualPrototypesError.prototype);
  }
}

export function requireEqualPrototypes(expectedProto: TypeCollection, providedProto: TypeCollection): void {
  if (expectedProto.length !== providedProto.length) {
    throw new NotEqualPrototypesError(expectedProto, providedProto);
  }
  for (let i = 0; i < expectedProto.length; ++i) {
    if (expectedProto[i] !== providedProto[i]) {
      throw new NotEqualPrototypesError(expectedProto, providedProto);
    }
  }
}
